<!-- Both tabs show the same search and list, so the panel is one template the tabs render with
     their own rows. The search term is deliberately shared: it filters whichever tab is open. -->
<ng-template #panel let-rows="rows">
    <cerrix-search-input
        class="search"
        name="link-items-search"
        [placeholder]="'searchPlaceholder' | t"
        [value]="searchTerm()"
        (valueChange)="searchTerm.set($event)"
        [attr.data-uiid]="dataUiid + '--search'"
    />
    <div class="items" [attr.data-uiid]="dataUiid + '--items'">
        @for (row of rows; track row.item.id) {
            <app-cerrix-link-item-row
                [label]="row.label"
                [openAriaLabel]="'openItem' | t: { item: row.label }"
                [readonly]="row.item.locked"
                [selected]="isSelected(row.item)"
                (selectedChange)="setSelected(row.item, $event)"
                (detailsRequested)="itemDetailsRequested.emit(row.item)"
                [attr.data-uiid]="dataUiid + '--item-' + row.item.id"
            />
        } @empty {
            <p class="empty">
                {{ (searchTerm().trim() ? "noSearchResults" : "noItems") | t }}
            </p>
        }
    </div>
</ng-template>

<cerrix-confirm-dialog
    [name]="name()"
    [title]="title()"
    [cancelText]="'cancel' | t"
    [confirmText]="'confirm' | t"
    confirmColor="green"
    [dataUiid]="dataUiid"
    (cancel)="cancel()"
    (confirm)="confirm()"
    (closed)="onClosed()"
>
    <div class="link-items-dialog-content">
        <app-cerrix-tabs>
            <ng-template appCerrixTab [label]="'tabAllItems' | t">
                <ng-container
                    [ngTemplateOutlet]="panel"
                    [ngTemplateOutletContext]="{ rows: allRows() }"
                />
            </ng-template>
            <ng-template appCerrixTab [label]="'tabLinked' | t">
                <ng-container
                    [ngTemplateOutlet]="panel"
                    [ngTemplateOutletContext]="{ rows: linkedRows() }"
                />
            </ng-template>
        </app-cerrix-tabs>
    </div>
</cerrix-confirm-dialog>
